import Vue from 'vue'

export default ({ app, $axios }) => {
  // filters
  Vue.filter('formatNumber', function (number) {
    return number.toLocaleString()
  })
}
